import styled from "styled-components/native";

export default styled.TouchableOpacity`
  padding: 5px;
  width: 50%;
`;
